import React from "react";
import { Box, Stack, Typography } from "@mui/joy";
import CustomTypography from "../../../common/CustomTypography";
import { theme } from "styles/theme";
import doctor1Img from "static/image/payment/doctor_1.png";
import doctor2Img from "static/image/payment/doctor_2.png";
import doctor3Img from "static/image/payment/doctor_3.png";

interface Doctor {
  name: string;
  role: string;
  image: string;
}

const doctors: Doctor[] = [
  {
    name: "홍승주 대표",
    role: "의사, 서울의대 졸업",
    image: doctor1Img,
  },
  {
    name: "오진승 원장",
    role: "정신과 전문의, Medical Advisor",
    image: doctor2Img,
  },
  {
    name: "김병수 원장",
    role: "정신과 전문의, Medical Advisor",
    image: doctor3Img,
  },
];

const DoctorCard = ({ doctor }: { doctor: Doctor }) => (
  <Stack spacing={"20px"} alignItems="center">
    <Box
      sx={{
        width: "200px",
        height: "200px",
        position: "relative",
        overflow: "hidden",
        flexShrink: 0,
      }}
    >
      <img
        src={doctor.image}
        alt={doctor.name}
        style={{
          position: "absolute",
          objectFit: "cover",
        }}
      />
    </Box>
    <Stack alignItems="center" spacing={"2px"}>
      <Typography
        variant={"Subtitle"}
        sx={{
          fontWeight: 700,
          color: theme.vars.palette.Content.Medium,
          textAlign: "center",
        }}
      >
        {doctor.name}
      </Typography>
      <Typography
        variant={"Subtitle"}
        sx={{
          fontWeight: 500,
          color: theme.vars.palette.Content.Medium,
          textAlign: "center",
        }}
      >
        {doctor.role}
      </Typography>
    </Stack>
  </Stack>
);

export default function DoctorsSection() {
  return (
    <Stack
      spacing={"40px"}
      alignItems="center"
      sx={{
        backgroundColor: theme.vars.palette.Background.Level3,
        width: "100%",
        px: "36px",
        py: "80px",
      }}
    >
      <Stack
        spacing={"12px"}
        alignItems="center"
        sx={{ width: "100%", maxWidth: "560px" }}
      >
        <CustomTypography
          variant="H2"
          sx={{
            fontWeight: 700,
            color: theme.vars.palette.Content.Strong,
            textAlign: "center",
          }}
        >
          {"의사가 만든 프로그램"}
        </CustomTypography>
        <CustomTypography
          variant="Subtitle"
          sx={{
            fontWeight: 500,
            color: theme.vars.palette.Content.Medium,
            textAlign: "center",
          }}
        >
          {
            "서울의대 출신 홍승주 대표/의사를 포함한 연구팀이 직접 연구 및 개발하고, 정신건강 전문가가 자문합니다."
          }
        </CustomTypography>
      </Stack>

      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={"40px"}
        alignItems="center"
        justifyContent="center"
        sx={{ width: "100%" }}
      >
        {doctors.map((doctor) => (
          <DoctorCard key={doctor.name} doctor={doctor} />
        ))}
      </Stack>
    </Stack>
  );
}
